import { create } from "apisauce";
import cache from "../Utility/cache";

const apiClient = create({
  baseURL: "http://192.168.1.104:9000/api",
});

const get = apiClient.get;
apiClient.secureGet = async (url, params, axiosConfig) => {
  const response = await get(url, params, axiosConfig);
  if (response.ok) {
    cache.store(url, response.data);
    return response;
  }
  console.error("Error while fetching from network", response.problem);
  const data = await cache.get(url);
  return data
    ? {
        ok: true,
        data,
      }
    : response;
};

export default apiClient;

// apiClient.get('/listings').then(response => {
//     if(!response.ok)

// });
